import UserGroupDetail from './UserGroupDetail';

export default UserGroupDetail;
